<template>
  <div class="session-gate">
    <!-- Loading state -->
    <div v-if="loading" class="session-loading">
      <div class="loader"></div>
      <p>Connecting to AR session...</p>
    </div>

    <!-- Error state -->
    <div v-else-if="error" class="session-error">
      <h3>Session Error</h3>
      <p>{{ error }}</p>
      <button @click="retrySession">Try Again</button>
    </div>

    <!-- Session active - show content -->
    <div v-else class="session-active">
      <div class="session-indicator" :title="'Session: ' + sessionId">
        <span class="session-dot"></span>
        <span class="session-text">{{ sessionId }}</span>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import sessionService from '../services/session';

export default {
  name: 'SessionGate',
  data() {
    return {
      loading: true,
      error: null,
      sessionId: null
    };
  },
  async mounted() {
    await this.initializeSession();

    // Listen for session errors
    window.addEventListener('session-error', this.handleSessionError);
  },
  beforeDestroy() {
    window.removeEventListener('session-error', this.handleSessionError);
  },
  methods: {
    async initializeSession() {
      this.loading = true;
      this.error = null;

      try {
        this.sessionId = await sessionService.initialize();
        this.loading = false;
      } catch (err) {
        this.error = err.message || 'Failed to connect to AR session';
        this.loading = false;
      }
    },
    async retrySession() {
      await this.initializeSession();
    },
    handleSessionError(event) {
      this.error = event.detail.message;
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.session-gate {
  width: 100%;
  min-height: 100vh;
}

.session-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

.session-loading p {
  margin-top: 20px;
  color: #666;
  font-size: 14px;
}

.session-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 20px;
}

.session-error h3 {
  color: #e74c3c;
  margin-bottom: 10px;
}

.session-error p {
  color: #666;
  margin-bottom: 20px;
  text-align: center;
}

.session-error button {
  line-height: 38px;
  padding: 0 30px;
  font-size: 0.875rem;
  color: #fff;
  background-color: #1e87f0;
  border: 1px solid transparent;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}

.session-active {
  position: relative;
}

.session-indicator {
  position: fixed;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  background: rgba(46, 204, 113, 0.1);
  border: 1px solid rgba(46, 204, 113, 0.3);
  border-radius: 4px;
  font-size: 11px;
  color: #27ae60;
  z-index: 1000;
}

.session-dot {
  width: 8px;
  height: 8px;
  background: #27ae60;
  border-radius: 50%;
  margin-right: 6px;
  animation: pulse 2s infinite;
}

.session-text {
  font-family: monospace;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.loader {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
